import React, { useCallback, useRef } from 'react';
import { recordLandingDemoVideoPlay } from '../../services/landingVideoAnalytics';

export const DEMO_VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/videos/smileconsent-product-demo.mp4`;
export const DEMO_VIDEO_POSTER = `${process.env.PUBLIC_URL || ''}/videos/smileconsent-product-demo-poster.jpg`;

/**
 * Full-width product demo presentation for Homepage V2.
 * Reuses the existing product demo video asset.
 */
export default function ProductDemoStage({ className = '' }) {
  const countedRef = useRef(false);

  const onPlay = useCallback(() => {
    if (countedRef.current) return;
    countedRef.current = true;
    recordLandingDemoVideoPlay();
  }, []);

  return (
    <figure className={`hpv2-product-stage ${className}`.trim()} aria-label="SmileConsent product demo">
      <div className="hpv2-product-frame">
        <div className="hpv2-product-chrome" aria-hidden="true">
          <div className="hpv2-product-dots">
            <span />
            <span />
            <span />
          </div>
          <div className="hpv2-product-url">smileconsent.co.uk — Product overview</div>
        </div>
        <div className="hpv2-product-video">
          <video
            controls
            playsInline
            preload="none"
            poster={DEMO_VIDEO_POSTER}
            controlsList="nodownload"
            title="SmileConsent product overview demo"
            onPlay={onPlay}
          >
            <source src={DEMO_VIDEO_SRC} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </figure>
  );
}
